import React, { createContext, useState, useContext } from "react";
interface TitleContextType {
  title: string;
  updateTitle: (title: string) => void;
}
const TitleContext = createContext<TitleContextType>({
  title: "",
  updateTitle: () => {},
});

export const useTitle = () => useContext(TitleContext);

export const TitleProvider = ({ children }) => {
  const [title, setTitle] = useState<string>(document.title);

  const updateTitle = (newTitle: string) => {
    document.title = `Pronto Valet - ${newTitle}`;
    setTitle(newTitle);
  };

  return (
    <TitleContext.Provider value={{ title, updateTitle }}>
      {children}
    </TitleContext.Provider>
  );
};
